jQuery(document).ready(function () {
    const rightShiftWeekday = (day) => (day === 6 ? 0 : day + 1);
    const rightShiftWeekdays = (weekdays) =>
        weekdays.map((weekday) => rightShiftWeekday(weekday));

    jQuery(".datepicker").matchHeight();

    window.update_datepicker_start_end_dates = function () {
        // Datepicker
        const datePickerInputJqEl = jQuery(".datepicker input");
        const datePickerJqEl = jQuery(".datepicker");

        // Do nothing if no datepickers present
        if (!datePickerJqEl.length) return;

        if (Modernizr.touchevents && Modernizr.inputtypes.date) {
            // make iOS and Android use native datepicker
            datePickerInputJqEl.prop("type", "date");
            // TODO: Needs some business logic such as in the datepicker configuration
            // for now we just set the default date
            datePickerInputJqEl.val(moment().add(1, "d").format("YYYY-MM-DD"));

            datePickerJqEl
                .removeClass("datepicker")
                .addClass("native-datepicker");
        } else {
            // localize date, it comes as ISO from Django
            datePickerInputJqEl.each(function () {
                const d = new Date(jQuery(this).val());
                if (!isNaN(d.getTime())) {
                    // TODO: i18n
                    const date_string_de =
                        ("0" + d.getDate()).slice(-2) +
                        "." +
                        ("0" + (d.getMonth() + 1)).slice(-2) +
                        "." +
                        d.getFullYear();
                    jQuery(this).val(date_string_de);
                }
            });

            const datePickerParams = {
                format: "DD.MM.YYYY",
                minDate: moment().add(1, "d").startOf("day"),
                locale: moment.locale(jQuery("body").data("locale")),
                showTodayButton: false,
                sideBySide: false,
                showClear: true,
                debug: false, // Switch to true when you try to debug
                widgetPositioning: {
                    horizontal: "auto",
                    vertical: "bottom",
                },
                tooltips: {
                    clear: "Clear selection",
                },
            };

            let earlyBookingEnabled = datePickerJqEl.data("eb-enabled");
            let earlyBookingStartDate = datePickerJqEl.data("eb-start-date");
            let earlyBookingEndDate = datePickerJqEl.data("eb-end-date");
            let earlyBookingClosedWeekdays =
                datePickerJqEl.data("eb-closed-weekdays");
            if (earlyBookingClosedWeekdays)
                earlyBookingClosedWeekdays =
                    earlyBookingClosedWeekdays.toString();
            let earlyBookingMinimumLeadDays = datePickerJqEl.data(
                "eb-minimum-lead-days",
            );
            let isClickEvent = datePickerJqEl.data("eb-click-event");

            // Add lead days to default date
            let defaultDate = moment().add(
                earlyBookingMinimumLeadDays
                    ? earlyBookingMinimumLeadDays + 1
                    : 1,
                "d",
            );

            if (
                earlyBookingEnabled &&
                earlyBookingEnabled.toString().toLowerCase() === "true"
            ) {
                // IMPORTANT: REMEMBER: moment isoWeekday() is 1-7 (mon-sun) and weekday is 0-6 (sun-sat)
                // Min Date is either earlyBookingStart Date or tomorrow's date. Which ever is latest from Today
                let minDate;
                if (earlyBookingStartDate)
                    minDate = new Date(earlyBookingStartDate);
                else minDate = undefined;

                const closedWeekdays = rightShiftWeekdays(
                    earlyBookingClosedWeekdays
                        .split(",")
                        .map((stringWeekday) => Number(stringWeekday)),
                );

                if (earlyBookingClosedWeekdays) {
                    datePickerParams.daysOfWeekDisabled = closedWeekdays;
                    if (closedWeekdays.includes(defaultDate.weekday())) {
                        // Get the closes day with respect to selected available weekdays
                        if (closedWeekdays.length < 7) {
                            let newDate = defaultDate;
                            for (let i = 0; i < 6; i++) {
                                newDate = newDate.add(1, "d");

                                if (
                                    !closedWeekdays.includes(newDate.weekday())
                                ) {
                                    defaultDate = newDate;
                                    break;
                                }
                            }
                        }
                    }
                }

                // Updated default date should become the new minDate
                if (!minDate || minDate < defaultDate) {
                    minDate = moment(defaultDate);
                }

                datePickerParams.minDate = moment(minDate).startOf("day");
                if (earlyBookingEndDate) {
                    const maxDate = new Date(earlyBookingEndDate);
                    if (minDate < maxDate) {
                        datePickerParams.maxDate =
                            moment(maxDate).startOf("day");
                    }
                }
            }

            // If already exists vs initiating new datetimepicker
            datePickerInputJqEl.each(function () {
                let d = jQuery(this).data("DateTimePicker");

                if (
                    jQuery(this).data("DateTimePicker") &&
                    isClickEvent &&
                    isClickEvent.toString() === "true"
                ) {
                    const dateTimePickerData =
                        jQuery(this).data("DateTimePicker");
                    datePickerParams.minDate &&
                        dateTimePickerData.minDate(datePickerParams.minDate);
                    datePickerParams.maxDate &&
                        dateTimePickerData.maxDate(datePickerParams.maxDate);
                    datePickerParams.daysOfWeekDisabled &&
                        dateTimePickerData.daysOfWeekDisabled(
                            datePickerParams.daysOfWeekDisabled,
                        );
                } else {
                    datePickerInputJqEl.datetimepicker(datePickerParams);
                }
            });

            // handle default date (is it set from the backend?)
            datePickerInputJqEl.each(function () {
                if (!jQuery(this).attr("value")) {
                    jQuery(this)
                        .data("DateTimePicker")
                        .date(defaultDate.toDate());
                }
            });
        }

        // end date cannot be before start date
        if (Modernizr.touchevents && Modernizr.inputtypes.date) {
            // mobile solution
            jQuery(".native-datepicker .start_date").each(function (i) {
                const start_date_el = jQuery(this);
                const end_date_el = jQuery(
                    start_date_el.closest("form").find(".end_date"),
                ).first();
                start_date_el.on("blur change", function (ev) {
                    const start_date = this.value;
                    const end_date = end_date_el.value;
                    if (moment(start_date).isAfter(end_date, "day")) {
                        end_date_el.val(
                            moment(start_date).format("YYYY-MM-DD"),
                        );
                    }
                });
            });
        } else {
            // desktop solution
            // watch out - there are two datepicker on the homepage for responsive styling reasons
            // -> mobile and desktop styling is very different.
            // TODO: clean this up but watch out: screen width media queries != Modernizr.touchevents

            jQuery(".datepicker .start_date").each(function (i) {
                const start_date_el = jQuery(this);
                const end_date_el = jQuery(
                    start_date_el.closest("form").find(".end_date"),
                );
                start_date_el.on("dp.change", function (e) {
                    const start_date = start_date_el
                        .data("DateTimePicker")
                        .date();
                    const end_date = end_date_el.data("DateTimePicker").date();
                    if (moment(start_date).isAfter(end_date, "day")) {
                        end_date_el
                            .data("DateTimePicker")
                            .date(moment(start_date));
                    }
                });
            });
        }
    };
    window.update_datepicker_start_end_dates();
});



// WEBPACK FOOTER //
// ./private/js/datetimepicker.js